import { useId } from "react";
import { AccessRequestButton } from "@/components/access-request-button";
import { SectionShell } from "@/components/section-shell";
import { cn } from "@/lib/utils";

export function CtaSection({
  heading,
  subhead,
  tagline,
  buttonText = "Request access",
  bg,
  className,
}: {
  heading: string;
  subhead?: string;
  tagline?: string;
  buttonText?: string;
  bg?: "paper" | "surface";
  className?: string;
}) {
  const headingId = useId();
  return (
    <SectionShell
      aria-labelledby={headingId}
      {...(bg !== undefined && { bg })}
      padding="hero"
      className={cn("text-center", className)}
    >
      <h2
        id={headingId}
        className={cn(
          "font-heading text-[2.25rem] font-semibold tracking-tight text-foreground",
          subhead ? null : "mb-8",
        )}
      >
        {heading}
      </h2>
      {subhead ? (
        <p className="mx-auto mt-4 mb-8 max-w-2xl text-base text-foreground-muted">{subhead}</p>
      ) : null}
      <AccessRequestButton size="lg">{buttonText}</AccessRequestButton>
      {tagline ? (
        <p className="mt-10 text-sm text-foreground-muted">{tagline}</p>
      ) : null}
    </SectionShell>
  );
}
